/* eslint-env browser */
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import ClientSideConfigSelector from '../../../recoil/cashout/ClientSideConfigSelector';

export default function ClaimRewardsNavbar({ onClose }) {
  const { ready } = useTranslation(null, { useSuspense: false });
  const config = useRecoilValue(ClientSideConfigSelector);

  const {
    live: {
      claimReward: {
        suppressNavbar = false,
      } = {},
    },
  } = config;

  if (!ready) {
    return null;
  }

  if (suppressNavbar) {
    return null;
  }

  return (
    <div id="site-nav" className="ui-bootstrap">
      <nav className="navbar navbar-default navbar-fixed-top hidden-xs hidden-sm" role="navigation">
        <div className="container phoenix-nav">
          <div className="nav-logo-container">
            <div className="nav-platform-logo" />
          </div>
          <ul className="nav navbar-nav">
            {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
            <li
              id="nav-icon"
              className="hidden-xs hidden-sm"
              onClick={onClose}
              onKeyDown={() => {}}
              /* eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role */
              role="button"
            >
              <div className="phoenix-icon phoenix-icon-back" />
            </li>
          </ul>
        </div>
      </nav>
      <div className="nav-titlebar container hidden-md hidden-lg" data-title="{{title}}" role="navigation">
        <div className="nav-titlebar-back">
          <span
            className="phoenix-icon phoenix-icon-back"
            onClick={onClose}
            role="button"
            tabIndex="0"
            aria-label="back"
            onKeyDown={() => {}}
          />
        </div>
      </div>
    </div>
  );
}

ClaimRewardsNavbar.propTypes = {
  onClose: PropTypes.func.isRequired,
};
